import { IconWrapper, Input, InputContainer, InputWrapper, ListItem, ListWrapper } from './styled';
//输入框加号图标
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import keyboard from '../../assets/keyboard.svg'; //视频通话按钮

import * as SpeechSDK from 'microsoft-cognitiveservices-speech-sdk';
import { ReactComponent as CancelIcon } from '../../assets/cancelButton.svg';
import { containerState } from '../../constant';
import EmojiList from '../../pages/editor/EmojiList';
import { getDownloadPreSignedUrl, getUploadPreSignedUrl } from '../../utils/api';
import './index.scss';
// 定义图片和视频的后缀名数组
const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif'];
const videoExtensions = ['.mp4', '.mov', '.avi'];

const ChatMobileInput = (props) => {
  const {
    sendMessage,
    handleOpenVideo,
    chatConfig,
    inputDisable,
    setUploadCancelToken,
    setUploadProgress,
    updateMessageById,
    setMobileAgentDisabled,
    agentDisabled,
    channel,
    IMWebClient,
    setFileSizeErrorModal,
  } = props;
  const [isComposing, setIsComposing] = useState(false);
  const MornIcon = () => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24.4999 12.5H15.4999V3.50003C15.4999 2.672 14.8279 2 13.9999 2C13.1719 2 12.4999 2.672 12.4999 3.50003V12.5H3.50003C2.672 12.5 2 13.172 2 14C2 14.828 2.672 15.5 3.50003 15.5H12.5V24.5C12.5 25.3295 13.172 26 14 26C14.828 26 15.5 25.3295 15.5 24.5V15.4999H24.5C25.3295 15.4999 26 14.8279 26 13.9999C26 13.1719 25.3294 12.5 24.4999 12.5Z"
        fill="#666666"
      />
    </svg>
  );
  const SentButton = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
      <rect x="0.799805" width="28" height="28" rx="14" fill="#666" />
      <path
        d="M15.4998 22.05C15.4998 22.4366 15.1864 22.75 14.7998 22.75C14.4132 22.75 14.0998 22.4366 14.0998 22.05H15.4998ZM14.3048 5.45503C14.5782 5.18166 15.0214 5.18166 15.2948 5.45503L19.7496 9.9098C20.0229 10.1832 20.0229 10.6264 19.7496 10.8998C19.4762 11.1731 19.033 11.1731 18.7596 10.8998L14.7998 6.93995L10.84 10.8998C10.5666 11.1731 10.1234 11.1731 9.85006 10.8998C9.57669 10.6264 9.57669 10.1832 9.85006 9.9098L14.3048 5.45503ZM14.0998 22.05V5.95H15.4998V22.05H14.0998Z"
        fill="white"
      />
    </svg>
  );
  const AudioIcon = () => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <circle cx="14" cy="14" r="14" fill="#666" />
        <path
          d="M6.30002 16.1C6.30002 16.4866 5.98662 16.8 5.60002 16.8C5.21343 16.8 4.90002 16.4866 4.90002 16.1V11.9C4.90002 11.5134 5.21343 11.2 5.60002 11.2C5.98662 11.2 6.30002 11.5134 6.30002 11.9V16.1ZM23.1 11.9C23.1 11.5134 22.7866 11.2 22.4 11.2C22.0134 11.2 21.7 11.5134 21.7 11.9V16.1C21.7 16.4866 22.0134 16.8 22.4 16.8C22.7866 16.8 23.1 16.4866 23.1 16.1V11.9ZM10.5 10.5C10.5 10.1134 10.1866 9.8 9.80002 9.8C9.41343 9.8 9.10002 10.1134 9.10002 10.5V17.5C9.10002 17.8866 9.41343 18.2 9.80002 18.2C10.1866 18.2 10.5 17.8866 10.5 17.5V10.5ZM18.9 10.5C18.9 10.1134 18.5866 9.8 18.2 9.8C17.8134 9.8 17.5 10.1134 17.5 10.5V17.5C17.5 17.8866 17.8134 18.2 18.2 18.2C18.5866 18.2 18.9 17.8866 18.9 17.5V10.5ZM14.7 7.7C14.7 7.3134 14.3866 7 14 7C13.6134 7 13.3 7.3134 13.3 7.7V20.3C13.3 20.6866 13.6134 21 14 21C14.3866 21 14.7 20.6866 14.7 20.3V7.7Z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="clip0_15451_84373">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
  const PicIcon = () => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.7344 3.68818H6.26669C4.84481 3.68818 3.68872 4.84427 3.68872 6.26615V21.7339C3.68872 23.1557 4.84481 24.3118 6.26669 24.3118H21.7344C23.1551 24.3118 24.3124 23.1557 24.3124 21.7339V6.26615C24.3124 4.84427 23.1551 3.68818 21.7344 3.68818H21.7344ZM23.0234 21.7339C23.0234 22.4442 22.4436 23.0228 21.7344 23.0228H6.26672C5.55521 23.0228 4.97773 22.4442 4.97773 21.7339V6.26615C4.97773 5.55576 5.55521 4.97716 6.26672 4.97716H21.7344C22.4436 4.97716 23.0234 5.55576 23.0234 6.26615V21.7339ZM16.7974 16.712L19.1908 14.7975L20.7319 15.824C20.843 15.8974 20.9668 15.9329 21.0905 15.9329C21.299 15.9329 21.5018 15.8321 21.6279 15.6464C21.8249 15.3497 21.747 14.951 21.4491 14.7539L19.5151 13.4649C19.2745 13.3034 18.9732 13.3343 18.76 13.5039L18.7543 13.4959L15.6894 15.9501L11.1442 12.8233C11.1419 12.8222 11.1396 12.8222 11.1384 12.821C11.0858 12.7866 11.025 12.766 10.9655 12.7488C10.9448 12.7431 10.9276 12.7271 10.9059 12.7248C10.852 12.7133 10.7947 12.719 10.7386 12.7225C10.7134 12.7248 10.6859 12.7179 10.6618 12.7225C10.6332 12.7282 10.6068 12.7465 10.5805 12.7546C10.5278 12.7717 10.4751 12.7855 10.4281 12.8164C10.4258 12.8176 10.4224 12.8176 10.4212 12.8187L6.55429 15.3967C6.25756 15.5938 6.17848 15.9936 6.37554 16.2904C6.4993 16.4772 6.70438 16.5768 6.9129 16.5768C7.03437 16.5768 7.15927 16.5413 7.2704 16.468L10.7741 14.1329L20.7284 20.9754C20.8407 21.0522 20.9656 21.0888 21.0917 21.0888C21.2967 21.0888 21.4972 20.9914 21.6233 20.8104C21.8249 20.5159 21.7504 20.1172 21.4572 19.9144L16.7974 16.712ZM15.6104 12.0659C17.2087 12.0659 18.5114 10.7655 18.5114 9.16606C18.5114 7.56659 17.2087 6.26615 15.6103 6.26615C14.0109 6.26615 12.7116 7.56771 12.7116 9.16606C12.7116 10.7644 14.0109 12.0659 15.6104 12.0659ZM15.6104 7.5551C16.4995 7.5551 17.2224 8.27807 17.2224 9.16606C17.2224 10.0529 16.4995 10.7758 15.6103 10.7758C14.7235 10.7758 14.0006 10.0529 14.0006 9.16606C14.0006 8.2781 14.7201 7.5551 15.6104 7.5551Z"
        fill="#666"
        stroke="#666"
        stroke-width="0.5"
      />
    </svg>
  );
  const List1 = () => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M3.56455 5.42582C2.3854 5.42582 1.42582 6.3854 1.42582 7.56455V20.4354C1.42582 21.6146 2.3854 22.5742 3.56455 22.5742H17.8655C19.0461 22.5742 20.0043 21.6146 20.0043 20.4354V7.56455C20.0043 6.3854 19.0447 5.42582 17.8655 5.42582H3.56455ZM17.8655 24H3.56455C2.61941 23.9992 1.71319 23.6235 1.04487 22.9551C0.376548 22.2868 0.000755217 21.3806 0 20.4354V7.56455C0 5.59835 1.59835 4 3.56455 4H17.8655C19.8332 4 21.4301 5.59835 21.4301 7.56455V20.4354C21.4301 22.4031 19.8332 24 17.8655 24Z"
          fill="#666"
          stroke="#666"
          stroke-width="0.195312"
        />
        <path
          d="M21.43 16.8909L25.7203 18.974V9.02606L21.43 11.1092V16.8909ZM26.4332 20.8262C26.3247 20.826 26.2175 20.8017 26.1195 20.7549L20.4063 17.9788C20.2862 17.9199 20.1851 17.8286 20.1143 17.7152C20.0435 17.6018 20.0058 17.4709 20.0056 17.3372V10.6643C20.0054 10.5307 20.0426 10.3997 20.1132 10.2863C20.1838 10.1728 20.2849 10.0815 20.4049 10.0227L26.121 7.24521C26.2298 7.19218 26.3504 7.16774 26.4713 7.1742C26.5922 7.18067 26.7095 7.21782 26.8121 7.28217C26.9146 7.34651 26.9991 7.43591 27.0576 7.54195C27.116 7.64799 27.1465 7.76717 27.1461 7.88826V20.1132C27.1454 20.3021 27.07 20.483 26.9365 20.6165C26.803 20.7501 26.6221 20.8254 26.4332 20.8262ZM12.4587 19.0111H5.13003C4.94095 19.0111 4.75962 18.936 4.62592 18.8023C4.49222 18.6686 4.41711 18.4873 4.41711 18.2982C4.41711 18.1091 4.49222 17.9278 4.62592 17.7941C4.75962 17.6604 4.94095 17.5853 5.13003 17.5853H12.4587C12.6478 17.5853 12.8292 17.6604 12.9629 17.7941C13.0965 17.9278 13.1717 18.1091 13.1717 18.2982C13.1717 18.4873 13.0965 18.6686 12.9629 18.8023C12.8292 18.936 12.6478 19.0111 12.4587 19.0111Z"
          fill="#666"
          stroke="#666"
          stroke-width="0.195312"
        />
      </g>
      <defs>
        <clipPath id="clip0_15451_84432">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
  const List2 = () => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.7344 3.68818H6.26669C4.84481 3.68818 3.68872 4.84427 3.68872 6.26615V21.7339C3.68872 23.1557 4.84481 24.3118 6.26669 24.3118H21.7344C23.1551 24.3118 24.3124 23.1557 24.3124 21.7339V6.26615C24.3124 4.84427 23.1551 3.68818 21.7344 3.68818H21.7344ZM23.0234 21.7339C23.0234 22.4442 22.4436 23.0228 21.7344 23.0228H6.26672C5.55521 23.0228 4.97773 22.4442 4.97773 21.7339V6.26615C4.97773 5.55576 5.55521 4.97716 6.26672 4.97716H21.7344C22.4436 4.97716 23.0234 5.55576 23.0234 6.26615V21.7339ZM16.7974 16.712L19.1908 14.7975L20.7319 15.824C20.843 15.8974 20.9668 15.9329 21.0905 15.9329C21.299 15.9329 21.5018 15.8321 21.6279 15.6464C21.8249 15.3497 21.747 14.951 21.4491 14.7539L19.5151 13.4649C19.2745 13.3034 18.9732 13.3343 18.76 13.5039L18.7543 13.4959L15.6894 15.9501L11.1442 12.8233C11.1419 12.8222 11.1396 12.8222 11.1384 12.821C11.0858 12.7866 11.025 12.766 10.9655 12.7488C10.9448 12.7431 10.9276 12.7271 10.9059 12.7248C10.852 12.7133 10.7947 12.719 10.7386 12.7225C10.7134 12.7248 10.6859 12.7179 10.6618 12.7225C10.6332 12.7282 10.6068 12.7465 10.5805 12.7546C10.5278 12.7717 10.4751 12.7855 10.4281 12.8164C10.4258 12.8176 10.4224 12.8176 10.4212 12.8187L6.55429 15.3967C6.25756 15.5938 6.17848 15.9936 6.37554 16.2904C6.4993 16.4772 6.70438 16.5768 6.9129 16.5768C7.03437 16.5768 7.15927 16.5413 7.2704 16.468L10.7741 14.1329L20.7284 20.9754C20.8407 21.0522 20.9656 21.0888 21.0917 21.0888C21.2967 21.0888 21.4972 20.9914 21.6233 20.8104C21.8249 20.5159 21.7504 20.1172 21.4572 19.9144L16.7974 16.712ZM15.6104 12.0659C17.2087 12.0659 18.5114 10.7655 18.5114 9.16606C18.5114 7.56659 17.2087 6.26615 15.6103 6.26615C14.0109 6.26615 12.7116 7.56771 12.7116 9.16606C12.7116 10.7644 14.0109 12.0659 15.6104 12.0659ZM15.6104 7.5551C16.4995 7.5551 17.2224 8.27807 17.2224 9.16606C17.2224 10.0529 16.4995 10.7758 15.6103 10.7758C14.7235 10.7758 14.0006 10.0529 14.0006 9.16606C14.0006 8.2781 14.7201 7.5551 15.6104 7.5551Z"
        fill="#666"
        stroke="#666"
        stroke-width="0.5"
      />
    </svg>
  );
  const List3 = () => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 7.33332C17.682 7.33332 20.6667 10.318 20.6667 14H18.6667C18.6667 13.0838 18.397 12.1879 17.8913 11.424C17.3855 10.6601 16.6661 10.0619 15.8227 9.70408C14.9793 9.34624 14.0493 9.24458 13.1485 9.41175C12.2477 9.57892 11.4161 10.0075 10.7572 10.6442C10.0984 11.2808 9.64152 12.0973 9.44358 12.9918C9.24563 13.8863 9.31537 14.8193 9.64409 15.6745C9.97281 16.5296 10.546 17.2691 11.2921 17.8007C12.0383 18.3324 12.9244 18.6326 13.84 18.664L14 18.6667C18.228 18.6667 21.8 21.478 22.9467 25.3333H20.8334C19.7667 22.602 17.1094 20.6667 14 20.6667C10.8907 20.6667 8.23335 22.602 7.16669 25.3333H5.05335C5.4391 24.0445 6.09817 22.8541 6.98564 21.843C7.8731 20.832 8.96811 20.0242 10.196 19.4747C9.31181 18.8615 8.58946 18.0432 8.09088 17.0897C7.59231 16.1362 7.33237 15.076 7.33335 14C7.33335 10.318 10.318 7.33332 14 7.33332ZM14 2.66666C18.924 2.66666 22.9574 6.47999 23.3087 11.314C23.8748 11.73 24.2949 12.3142 24.5092 12.9832C24.7235 13.6523 24.7209 14.3719 24.5019 15.0393C24.2828 15.7068 23.8585 16.288 23.2895 16.7C22.7205 17.112 22.0358 17.3336 21.3334 17.3333L17 17.334C16.7901 17.6138 16.4975 17.8205 16.1636 17.9248C15.8297 18.0291 15.4715 18.0257 15.1396 17.9151C14.8078 17.8045 14.5192 17.5923 14.3146 17.3085C14.1101 17.0247 14 16.6838 14 16.334C14 15.9842 14.1101 15.6432 14.3146 15.3595C14.5192 15.0757 14.8078 14.8635 15.1396 14.7529C15.4715 14.6422 15.8297 14.6388 16.1636 14.7431C16.4975 14.8474 16.7901 15.0541 17 15.334L21.3334 15.3333C21.687 15.3333 22.0261 15.1928 22.2762 14.9428C22.5262 14.6928 22.6667 14.3536 22.6667 14C22.6667 13.6464 22.5262 13.3072 22.2762 13.0572C22.0261 12.8071 21.687 12.6667 21.3334 12.6667V12C21.3334 7.94999 18.05 4.66666 14 4.66666C9.95002 4.66666 6.66669 7.94999 6.66669 12V12.6667C6.31306 12.6667 5.97393 12.8071 5.72388 13.0572C5.47383 13.3072 5.33335 13.6464 5.33335 14C5.33335 14.3536 5.47383 14.6928 5.72388 14.9428C5.97393 15.1928 6.31306 15.3333 6.66669 15.3333V17.3333C5.96436 17.3334 5.27996 17.1117 4.71112 16.6998C4.14229 16.2878 3.71811 15.7067 3.4991 15.0394C3.28009 14.3721 3.27745 13.6527 3.49155 12.9838C3.70565 12.3149 4.12556 11.7308 4.69135 11.3147C5.04269 6.47999 9.07602 2.66666 14 2.66666Z"
        fill="#666"
        stroke-width="0.5"
      />
    </svg>
  );
  const EmojiIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
      <rect opacity="0.01" width="28" height="28" fill="#333333" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.875 11.5117C7.875 12.2366 8.46263 12.8242 9.1875 12.8242C9.91237 12.8242 10.5 12.2366 10.5 11.5117C10.5 10.7868 9.91237 10.1992 9.1875 10.1992C8.46263 10.1992 7.875 10.7868 7.875 11.5117V11.5117ZM17.5 11.5117C17.5 12.2366 18.0876 12.8242 18.8125 12.8242C19.5374 12.8242 20.125 12.2366 20.125 11.5117C20.125 10.7868 19.5374 10.1992 18.8125 10.1992C18.0876 10.1992 17.5 10.7868 17.5 11.5117V11.5117ZM14 1.75C7.23516 1.75 1.75 7.23516 1.75 14C1.75 20.7648 7.23516 26.25 14 26.25C20.7648 26.25 26.25 20.7648 26.25 14C26.25 7.23516 20.7648 1.75 14 1.75ZM21.1914 21.1914C20.2562 22.1266 19.168 22.8594 17.9566 23.3734C16.707 23.9039 15.3754 24.1719 14 24.1719C12.6246 24.1719 11.293 23.9039 10.0406 23.3734C8.8293 22.8621 7.74102 22.1266 6.80586 21.1914C5.8707 20.2562 5.13789 19.168 4.62383 17.9566C4.09609 16.707 3.82812 15.3754 3.82812 14C3.82812 12.6246 4.09609 11.293 4.62656 10.0406C5.13789 8.8293 5.87344 7.74102 6.80859 6.80586C7.74375 5.8707 8.83203 5.13789 10.0434 4.62383C11.293 4.09609 12.6246 3.82812 14 3.82812C15.3754 3.82812 16.707 4.09609 17.9594 4.62656C19.1707 5.13789 20.259 5.87344 21.1941 6.80859C22.1293 7.74375 22.8621 8.83203 23.3762 10.0434C23.9039 11.293 24.1719 12.6246 24.1719 14C24.1719 15.3754 23.9039 16.707 23.3734 17.9594C22.8621 19.1707 22.1266 20.259 21.1914 21.1914ZM18.1563 14.5742H16.841C16.7262 14.5742 16.6277 14.6617 16.6195 14.7766C16.5156 16.1301 15.3809 17.1992 14 17.1992C12.6191 17.1992 11.4816 16.1301 11.3805 14.7766C11.3723 14.6617 11.2738 14.5742 11.159 14.5742H9.84375C9.71797 14.5742 9.61953 14.6781 9.625 14.8039C9.74532 17.109 11.6621 18.9492 14 18.9492C16.3379 18.9492 18.2547 17.109 18.375 14.8039C18.3805 14.6781 18.282 14.5742 18.1563 14.5742Z"
        fill="#666666"
      />
    </svg>
  );
  const [inputValue, setInputValue] = useState(''); //输入框内容
  const [showList, setShowList] = useState(false);
  const [inputFouce, setInputFouce] = useState(false); //输入框是否聚焦
  const dropdownRef = useRef(null);
  const [isAudio, setIsAudio] = useState(false); //是否是发送语音
  const audioButton = useRef();
  const [showEmojiPicker, setShowEmojiPicker] = useState(false); //是否显示表情选择器
  const textareaRef = useRef(null);
  const startXRef = useRef(0); // 使用 useRef 存储 startX，避免状态异步更新的问题
  let input = null;
  let hasChanged = false;
  let audioRecorder = {
    text: '',
    time: '',
  };
  // ------------speech语音Start----------------

  const [isListening, setIsListening] = useState(false);
  const noRecored = useRef(false);
  const [isSliding1, setIsSliding] = useState(false); // 是否正在滑动
  let isSliding = false;
  const channelRef = useRef('');
  const durationRef = useRef(0); // 使用 useRef 存储 startX，避免状态异步更新的问题
  const timerRef = useRef(null); // 使用 useRef 来存储定时器 ID
  const subscriptionKey = '16620ad218a347d0849d89995ad2288f'; // 替换为你的订阅密钥
  const region = 'eastus'; // 替换为你的服务区域（例如 'eastus'）
  const [noPermission, setNoPermission] = useState(false);
  let recognizer = null; // 将 recognizer 声明为组件的局部变量
  useEffect(() => {
    handleClickKeyBoard();
    channelRef.current = channel;
  }, [channel]);
  // 获取浏览器语言并选择对应的识别语言
  const getLanguageFromBrowser = () => {
    const userLang = navigator.language || navigator.userLanguage; // 获取浏览器的语言
    // let speechLanguage = 'en-US'; // 默认英语
    // console.log(userLang);
    // if (userLang.includes('zh')) {
    //   speechLanguage = 'zh-CN'; // 如果浏览器语言包含 'zh'，使用中文
    // }

    return userLang;
  };

  // 开始语音识别
  const startListening = () => {
    if (!isListening && recognizer == null) {
      audioRecorder.text = '';
      const lang = getLanguageFromBrowser();
      const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(subscriptionKey, region);
      speechConfig.speechRecognitionLanguage = lang;
      const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
      recognizer = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig);
      recognizer.recognizing = (sender, event) => {
        // console.log(event.result.text);
      };
      recognizer.recognized = (sender, event) => {
        if (event.result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
          // console.log(event.result.text);
          audioRecorder.text += event.result.text;
        }
      };
      recognizer.canceled = (sender, event) => {
        if (event.reason === SpeechSDK.CancellationReason.Error) {
          setErrorMessage(`识别失败: ${event.errorDetails}`);
        }
      };
      recognizer.startContinuousRecognitionAsync();
      setIsListening(true);
      startTimer(); // 启动计时器
    } else {
      recognizer.stopContinuousRecognitionAsync();
      stopTimer();
    }
  };
  // 启动计时器
  const startTimer = () => {
    if (timerRef.current) clearInterval(timerRef.current); // 防止多个计时器同时运行
    durationRef.current = 0; // 重置时长
    timerRef.current = setInterval(() => {
      durationRef.current++; //每秒增加 1
      // console.log(durationRef);
    }, 1000);
  };
  // 停止计时器
  const stopTimer = () => {
    if (timerRef.current) clearInterval(timerRef.current); // 清除计时器
    audioRecorder.time = formatDuration(durationRef.current);
    // console.log(audioRecorder);
  };
  // 格式化时长，转换为 "mm:ss" 格式
  const formatDuration = (duration) => {
    const minutes = Math.floor(duration / 60);
    const seconds = duration % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };
  // 停止语音识别
  const stopListening = () => {
    // setTimeout(() => {
    //   console.log(isSliding);
    // }, 0);
    // return;
    if (recognizer) {
      recognizer.stopContinuousRecognitionAsync(); //停止语音识别
      recognizer = null;
      setIsListening(false); //设置是否在听为false
      stopTimer(); //停止计时器
      noRecored.current = true;
      setTimeout(() => {
        if (!isSliding) {
          let messageId = sendMessage('', 'audio'); //发送一个正在转换的消息并保存messageId用于更新消息
          setTimeout(() => {
            //延时确保语音识别结束再发送消息
            updateMessageById(messageId); //告知父级要更新的消息id
            sendMessage(
              audioRecorder.text == '' ? chatConfig.noTextDetected : audioRecorder.text,
              'audio',
              '',
              audioRecorder.text == '' ? '' : true,
              '',
              audioRecorder.text == '' ? '' : 'none',
              audioRecorder.time,
              ''
            ); //发送消息以及时间，更新在上一条转换的messageId上
            setInputValue('');
            noRecored.current = false;
            // console.log('audioText>>>', audioRecorder);
          }, 3000);
        }
      }, 0);
    }
  };

  // 处理触摸开始事件
  const handleTouchStartAudio = (e) => {
    if (!noRecored.current) {
      e.preventDefault();
      // console.log('语音开始了');
      // console.log(e.touches[0].pageX);
      const touchStart = e.touches[0].pageX;
      startXRef.current = touchStart;
      isSliding = false;
      setIsSliding(false);
      startListening();
    }
  };

  // 处理触摸移动事件
  const handleTouchEndAudio = (e) => {
    // e.preventDefault();这里不要禁止默认事件，会导致移动事件在触摸过程中重置位置，造成识别移动错误。
    const touchMove = e.touches[0].pageX;
    // console.log('startX', startXRef.current);
    // console.log(Math.abs(e.touches[0].pageX - startXRef.current));
    if (Math.abs(e.touches[0].clientX - startXRef.current) > 20) {
      // 如果滑动超过50px，认为是滑动取消
      isSliding = true;
      setIsSliding(true);
    } else {
      isSliding = false;
      setIsSliding(false);
    }
    // console.log('isSliding>>>', isSliding);
  };

  // 处理触摸结束事件
  const handleEndAudio = (e) => {
    // e.preventDefault();
    stopListening(); // 如果没有滑动，松开停止语音识别
  };
  // ------------speech语音Start----------------
  //失焦处理
  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setShowList(false);
      setShowEmojiPicker(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  //输入框失去焦点
  const inputBlur = () => {
    // console.log('输入框失去焦点');
    //增加延迟避免用户是点击的下方功能失效
    setTimeout(() => {
      setInputFouce(false);
    }, 100);
  };
  //输入框获得焦点
  const inputFouces = () => {
    // console.log('输入框获得焦点');
    setShowList(false);
    setShowEmojiPicker(false);
    setInputFouce(true);
  };
  const handleChange = (e) => {
    let value = e.target.value;
    // 确保字符数不超过1000
    if (value.length > 1000) {
      value = value.substring(0, 1000);
    }
    IMWebClient?.userInput();
    setInputValue(value);
  };
  const pressSendMessage = () => {
    sendMessage(inputValue);
    setInputValue('');
  };
  const onKeyDown = (e) => {
    if (isComposing) {
      return;
    }
    if (inputDisable) {
      return;
    }
    if (e.keyCode !== 13) {
      return;
    }
    sendMessage(inputValue);
    setInputValue('');
  };

  const handleClickVideo = () => {
    setInputFouce(false);
    setInputValue('');
    handleOpenVideo(containerState.VIDEO);
    setShowList(!showList);
    setShowEmojiPicker(false);
  };
  // 切换语音模式
  const handleClickAudio = () => {
    setIsAudio(true);
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then(() => {
        setTimeout(() => {
          if (audioButton.current) {
            audioButton.current.addEventListener('touchstart', handleTouchStartAudio);
            audioButton.current.addEventListener('touchmove', handleTouchEndAudio);
            audioButton.current.addEventListener('touchend', handleEndAudio);
          }
        }, 100);
      })
      .catch(() => {
        // console.log('无录音权限');
        setNoPermission(true);
      });
  };
  const handleClickKeyBoard = () => {
    setIsAudio(false);
  };
  const handleUpload = () => {
    setTimeout(() => {
      // 执行上传
      input = document.createElement('input');
      setShowList(false);
      setShowEmojiPicker(false);
      input.type = 'file';
      input.accept = '*/*';
      input.onchange = async (event) => {
        hasChanged = true;
        const file = event.target.files[0];
        if (file.size > 200 * 1024 * 1024) {
          setFileSizeErrorModal(true);
          return;
        }
        const formData = new FormData();
        formData.append('file', file);
        // 创建一个新的取消令牌
        const source = axios.CancelToken.source();
        setUploadCancelToken(source);
        const now = new Date();
        const year = now.getFullYear();
        const month = (now.getMonth() + 1).toString().padStart(2, '0');
        const day = now.getDate().toString().padStart(2, '0');
        const date = `${year}/${month}/${day}`;

        let cancel = false;
        let fileName = new Date().getTime() + '_' + file.name;
        // 预签名
        await getUploadPreSignedUrl(fileName, file.type, chatConfig.companyId, date).then(async (res) => {
          let contentType = '';
          let contentType1 = '';
          if (isImage(fileName)) {
            contentType = 'image';
            contentType1 = 'image/jpeg';
          } else if (isVideo(fileName)) {
            contentType = 'video';
            contentType1 = 'video/mp4';
          } else {
            contentType = 'link';
            contentType1 = 'application/octet-stream';
          }

          // 发一个上传中的消息
          let messageId = await sendMessage(res.data, contentType, fileName, false, 0, 'active');
          // 使用干净的 axios 实例，避免默认/拦截器添加多余请求头
          const ax = axios.create();
          // 移除常见会触发预检或干扰 S3 的默认头
          if (ax.defaults && ax.defaults.headers && ax.defaults.headers.common) {
            delete ax.defaults.headers.common['X-Requested-With'];
            delete ax.defaults.headers.common['Content-Type'];
          }
          let headers = {
            'Content-Type': contentType1,
          };
          if (contentType == 'video') {
            headers['x-amz-tagging'] = 'FileType=large';
          }

          // 创建上传任务
          const upload = ax
            .put(res.data, file, {
              headers: headers,
              onUploadProgress: (progressEvent) => {
                let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                let progress = {
                  fileName: fileName,
                  progress: percentCompleted,
                };
                setUploadProgress((prevProgress) => {
                  return [...prevProgress.filter((upload) => upload.fileName !== fileName), progress];
                });
              },
              cancelToken: source.token,
            })
            .catch(async () => {
              updateMessageById(messageId, res.data, 'exception');
              cancel = true;
            })
            .finally(async () => {
              setUploadCancelToken(null);
              if (!cancel) {
                // 获取预签名url，显示附件
                await getDownloadPreSignedUrl(fileName, file.type, chatConfig.companyId, date).then(async (res) => {
                  if (res.code === 200) {
                    updateMessageById(messageId);
                    await sendMessage(res.data, contentType, fileName, false);
                  }
                });
              }
              // 在事件处理程序执行完毕后再移除input元素
              if (hasChanged) {
                input.remove();
                hasChanged = false;
              }
            });
        });
      };
      input.click();
    }, 300);
    //延迟保证收起键盘后显示选择图片菜单位置不漂移
  };

  // 判断文件后缀是否为图片
  const isImage = (fileName) => {
    const extension = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
    return imageExtensions.includes(extension);
  };

  // 判断文件后缀是否为视频
  const isVideo = (fileName) => {
    const extension = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
    return videoExtensions.includes(extension);
  };

  const handleClickCancel = (e) => {
    if (inputDisable) {
      return;
    }
    e.stopPropagation();
    setShowList(!showList);
    setShowEmojiPicker(false);
  };
  const handleClickToAgent = () => {
    // console.log('点击转人工');
    setMobileAgentDisabled(true);
    setShowList(false);
  };

  // 表情选择器相关处理
  const handleToggleEmoji = () => {
    setShowEmojiPicker(!showEmojiPicker);
    setShowList(false);
  };

  const handleClickEmoji = (emoji) => {
    const newValue = inputValue + emoji;
    // 确保字符数不超过1000
    if (newValue.length <= 1000) {
      setInputValue(newValue);
    }
    setShowEmojiPicker(false);
    // 获取输入框并聚焦
    if (textareaRef.current) {
      textareaRef.current.focus();
    }
  };
  return (
    <div style={{ height: '100%', position: 'relative', paddingBottom: '15px' }} ref={dropdownRef}>
      {isAudio ? (
        <InputContainer>
          <InputWrapper className="audioDiv" style={{ background: isListening ? chatConfig.chatThemeColor : '' }}>
            {isListening ? (
              ''
            ) : (
              <IconWrapper onClick={handleClickCancel}>
                <MornIcon />
              </IconWrapper>
            )}
            <div className="holdBox" ref={audioButton}>
              {noPermission ? (
                chatConfig.noRecordingPermission
              ) : !isListening ? (
                chatConfig.holdToSpeak
              ) : (
                <div className="apss">
                  <div className="ap">
                    <div className="box">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {isListening ? (
              ''
            ) : (
              <IconWrapper>
                <img src={keyboard} alt="" onClick={handleClickKeyBoard} />
              </IconWrapper>
            )}
            {isListening ? (
              <div className="audioTip">
                <div>{!isSliding1 ? chatConfig.slideUpToCancel : chatConfig.cancelSent}</div>
                <CancelIcon style={{ color: !isSliding1 ? '#80848F' : 'red' }} />
              </div>
            ) : (
              ''
            )}
          </InputWrapper>
        </InputContainer>
      ) : (
        <InputContainer className={inputFouce ? 'focusInput' : ''}>
          <InputWrapper className="inputWrapper">
            {inputFouce ? (
              ''
            ) : (
              <IconWrapper>
                {/* <div style={{ width: '28px', height: '28px' }} onClick={handleClickCancel}>
                  <MornIcon />
                </div> */}
                <div style={{ width: '28px', height: '28px' }} onClick={handleToggleEmoji}>
                  <EmojiIcon />
                </div>
              </IconWrapper>
            )}
            {!chatConfig.mobileEnterSendMessage ? (
              <textarea
                ref={textareaRef}
                className="inputTextArea"
                rows="1"
                style={{ height: inputFouce ? 'calc(100% - 48px)' : '30px', marginTop: inputFouce ? '5px' : '0px' }}
                value={inputValue}
                onChange={handleChange}
                // onKeyUp={onKeyDown}
                onFocus={inputFouces}
                onBlur={inputBlur}
                onCompositionStart={() => setIsComposing(true)} // 开始中文输入
                onCompositionEnd={() => setIsComposing(false)} // 中文输入完成
                maxLength={1000}
              ></textarea>
            ) : (
              <Input
                ref={textareaRef}
                type="text"
                value={inputValue}
                onChange={handleChange}
                onKeyUp={onKeyDown}
                onFocus={inputFouces}
                onBlur={inputBlur}
                onCompositionStart={() => setIsComposing(true)} // 开始中文输入
                onCompositionEnd={() => setIsComposing(false)} // 中文输入完成
                maxLength={1000}
              />
            )}
            {inputFouce ? (
              ''
            ) : chatConfig.enableAppVoiceInput != '1' ? (
              ''
            ) : (
              <IconWrapper style={{ marginRight: '10px' }} onClick={handleClickAudio}>
                {/* <img src={audio} alt="" onClick={handleClickAudio} /> */}
                <AudioIcon />
              </IconWrapper>
            )}
            {inputFouce ? (
              ''
            ) : (
              <IconWrapper style={{ marginRight: '8px' }} onClick={handleClickCancel}>
                <MornIcon />
              </IconWrapper>
            )}
            <div style={{ display: 'flex', position: 'relative' }} className={inputFouce ? 'inputTool' : 'displayNone'}>
              {/* <img style={{ color: 'red' }} src={serviceButton} alt="" onClick={handleClickCancel} /> */}
              {/* <div style={{ margin: '0 5px 0 10px' }} onClick={handleToggleEmoji}>
                <EmojiIcon />
              </div> */}
              {(chatConfig.chatOpenChannelType === '1' || chatConfig.chatOpenChannelType === '3') &&
              agentDisabled &&
              chatConfig.showToagentFlag === '1' ? (
                <div style={{ margin: '0 5px 0 0' }} className="agentButton" onClick={handleClickToAgent}>
                  <List3 style={{ color: '#999' }} />
                </div>
              ) : (
                ''
              )}
              {/* <img src={videoButton} alt="" onClick={handleClickVideo} /> */}
              {chatConfig.chatOpenChannelType !== '2' && chatConfig.openAudio === '1' ? (
                <div style={{ margin: '0 5px 0 0' }} onClick={handleClickVideo}>
                  <List1 style={{ color: '#999' }} />
                </div>
              ) : (
                ''
              )}
              <div onClick={handleUpload}>
                <PicIcon style={{ color: '#999' }} />
              </div>
              <div className="sentButton" onClick={pressSendMessage}>
                <SentButton style={{ color: '#999' }} />
              </div>
            </div>
          </InputWrapper>
        </InputContainer>
      )}
      <ListWrapper style={{ display: showList ? '' : 'none', bottom: '78px' }}>
        {chatConfig.chatOpenChannelType !== '2' && chatConfig.openAudio === '1' ? (
          <ListItem onClick={handleClickVideo} $chatLanguage={chatConfig.chatLanguage}>
            <span style={{ verticalAlign: 'super' }}> {chatConfig.openVideoButton}</span>
            <List1 />
          </ListItem>
        ) : (
          ''
        )}
        {/* {chatConfig.chatOpenChannelType !== '2' && chatConfig.openAudio === '1' ? <ListCut /> : ''} */}

        <ListItem onClick={handleUpload} $chatLanguage={chatConfig.chatLanguage}>
          <span style={{ verticalAlign: 'super' }}>{chatConfig.chatMobileUpload}</span>
          <List2 />
        </ListItem>
        {(chatConfig.chatOpenChannelType === '1' || chatConfig.chatOpenChannelType === '3') &&
        agentDisabled &&
        chatConfig.showToagentFlag === '1' ? (
          <ListItem onClick={handleClickToAgent} $chatLanguage={chatConfig.chatLanguage}>
            <span style={{ verticalAlign: 'super' }}>{chatConfig.menuToAgentTxt.split(',')[0]}</span>
            <List3 style={{ color: '#999' }} />
          </ListItem>
        ) : (
          ''
        )}
      </ListWrapper>
      {/* 表情选择器 */}
      <div className={`mobileEmojiPicker ${showEmojiPicker ? 'show' : ''}`}>
        {showEmojiPicker && <EmojiList handleClickEmoji={handleClickEmoji} />}
      </div>
    </div>
  );
};

export default ChatMobileInput;
